<template>
  <div style="text-align:center;">
    <h1 style = "font-weight: bold;">Simulated VODACOM Charge Page</h1><br>
    <div>Press one of the below buttons depending the response you want to simulate : </div><br>
    <div>
      <button type="button" @click.prevent="doNextAction(0)">Subscribe Success</button><br><br>
      <button type="button" @click.prevent="doNextAction(1)">Subscribe declined</button><br><br>
      <button type="button" @click.prevent="doNextAction(2)">Subscribe fraud</button><br><br>
      <button type="button" @click.prevent="doNextAction(3)">Subscribe error</button><br><br>
      <button type="button" @click.prevent="doNextAction(4)">Subscribe blocked</button><br><br>
      <button type="button" @click.prevent="doNextAction(5)">Subscribe no funds</button><br><br>
      <button type="button" @click.prevent="doNextAction(6)">Subscribe timeout</button><br><br>
      <button type="button" @click.prevent="doNextAction(7)">Subscribe already sub</button><br><br>
      <button type="button" @click.prevent="doNextAction(8)">Subscribe Invalid</button><br><br>
      <button type="button" @click.prevent="doNextAction(9)">Subscribe lock flag</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'consent',
  data() {
    return {
      callback: '',
      id: '',
    };
  },
  // eslint-disable-next-line
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.checkParameters(to);
    });
  },
  methods: {
    checkParameters(to) {
      this.callback = to.query['partner-redirect-url'];
      this.id = to.query['client-txn-id'];
    },
    doNextAction(action) {
      if (this.callback && this.id) {
        let code = 0;
        let result = 'ACCEPTED';
        let des = 'Successfully Subscribed';
        switch (action) {
        case 1: code = 1;
          result = 'DECLINED';
          des = 'Customer declined';
          break;
        case 2: code = 2;
          result = 'FRAUD';
          des = 'Fraud detected';
          break;
        case 3: code = 3;
          result = 'ERROR';
          des = 'An error has occurred';
          break;
        case 4: code = 4;
          result = 'BLOCKED';
          des = 'Content block flag set';
          break;
        case 5: code = 5;
          result = 'ERROR';
          des = 'Insufficient funds';
          break;
        case 6: code = 6;
          result = 'ERROR';
          des = 'Timeout waiting for response';
          break;
        case 7: code = 7;
          result = 'ERROR';
          des = 'Already subscribed to service';
          break;
        case 8: code = 8;
          result = 'ERROR';
          des = 'Invalid request';
          break;
        case 9: code = 9;
          result = 'BLOCKED';
          des = 'Admin lock flag set';
          break;
        default: break;
        }
        window.location.href = `${this.callback}?client-txn-id=${this.id}&status-code=${code}&result=${result}&result-description=${des}`;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Consent.vue